'use client';

import { ArrowRight } from '@/assets';
import Link from 'next/link';
import { SmallLoader } from '../SmallLoader/SmallLoader';
import { ButtonVariation } from './Button';
import staticStyles from './button.module.scss';

export interface Props {
  link?: string;
  text?: string;
  styles?: string;
  variation?: ButtonVariation;
  type?: 'button' | 'link';
  onClick?: () => void;
  target?: string;
  buttonType?: 'button' | 'submit' | 'reset';
  isArrow?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

const NextButton = ({
  link,
  text,
  styles,
  variation = 'primary',
  type = 'link',
  target,
  onClick,
  buttonType = 'button',
  isArrow = false,
  disabled = false,
  loading = false,
}: Props) => {
  if (type === 'button') {
    return (
      <button
        type={buttonType}
        onClick={onClick}
        className={`${staticStyles.button} ${staticStyles[variation]} ${styles}`}
        disabled={disabled}
      >
        <div className={staticStyles.text_wrapper}>
          <span>{text}</span>
          <span>{text}</span>
        </div>
        {loading ? <SmallLoader /> : isArrow && <ArrowRight />}
      </button>
    );
  }

  return (
    <Link
      target={target || ''}
      rel={target ? 'noreferrer noopener' : ''}
      className={`${styles} ${staticStyles.button} ${staticStyles[variation]}`}
      href={link || ''}
    >
      <div className={staticStyles.text_wrapper}>
        <span>{text}</span>
        <span>{text}</span>
      </div>
      {isArrow && <ArrowRight />}
    </Link>
  );
};

export default NextButton;
